export const MODAL_WIDTHS = {
    Large: 'l',
    Medium: 'm',
    Small: 's',
};
export const MODAL_HEIGHT_MODES = {
    Contents: 'contents',
    Fixed: 'fixed',
};
